export const version = 'kunde-v1.20.0-SNAPSHOT-c6f670ac7c14099d5906de491f843eb3dbd9b2ee';